<template>
  <div class="stationGroupForm tableStyle">
   <el-row>
        <el-form :inline="true" :model="queryForm" size="small">
            <el-form-item label="用户名：" class="screen">
                <el-input v-model="queryForm.user_name" placeholder="请输入用户名" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号：" class="screen">
                <el-input v-model="queryForm.mobile" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>            
            <el-form-item label="反馈内容：" class="screen">
                <el-input v-model="queryForm.content" placeholder="请输入反馈内容" clearable></el-input>
            </el-form-item>

            <el-form-item label="时间：" class="screen">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="dateChange"
                    clearable>
                </el-date-picker>
            </el-form-item>         

          <el-form-item>
            <el-button type="primary" @click="getTableList('query')">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
          </el-form-item>

        </el-form>
   </el-row>

    <div class="tableArea">
      <el-table :data="tableData" class="table-border" style="width: 100%" height="100%">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="user_name" label="用户名" align="center"></el-table-column>
        <el-table-column prop="mobile" label="用户手机号码" align="center"></el-table-column>
        <el-table-column prop="content" label="反馈内容" align="center"></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image class="feedbackImg" :src="config.imgUrl() + item" :preview-src-list="scope.row.attachment.map(item=>config.imgUrl() + item)" v-for="(item,index) in scope.row.attachment" :key="index"></el-image>            
          </template>          
        </el-table-column>
        <el-table-column prop="created_at" label="反馈时间" align="center"></el-table-column>
      </el-table>
    </div>

    <el-row class="pageFoot">
      <el-col :span="12">
        <div class="statistical">
          统计：{{total}}条
        </div>
      </el-col>
      <el-col :span="12">
        <el-pagination
          layout="total, prev, pager, next, sizes"
          background
          :page-size="queryForm.size"
          :total="total"
          :page-sizes="[20,50,100,200,500,1000]"
          @size-change="sizeChange"
          @current-change="changePage">
        </el-pagination>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import config from '@/http/config';
export default {
  data() {
    return {
        // size: 20,
        // page: 1,
        total: 0,
        // allManufacturer: [],

        config: config,
        //查询请求参数
        queryForm:{
          page: 1,
          size: 20,          
          user_name:'',
          mobile:'',
          content:'',
          date_start:'',
          date_end:'',
        },
        dateRange:[],


        // allStation:[], //所有桩群

        tableData: [],
        // inchargeTotal: 0,
        // costTotal: 0,
        // withdrwalTotal: 0,


        
    };
  },

  created() {
    this.init();
  },
  methods: {
    // 初始化
    init(){
      this.getTableList();
    },
    // 获取table列表
    getTableList(type){
        if(type === 'query'){
          this.queryForm.page = 1;
        }
        this.$http.get(this.common.admin + '/admin/feedbackList',{params:this.queryForm}).then(res => {
            if(res.code === 200){
                this.tableData = res.data.list;
                this.total = res.data.total;
            }else{
                this.$message.error(res.msg);
            }
        });



    },

  
    // 重置查询--运营端
    resetQuery() {
        this.queryForm = {
          page: 1,
          size: 20,          
          user_name:'',
          mobile:'',
          content:'',
          date_start:'',
          date_end:'', 
        },
        this.getTableList();
    },

    //搜索时间
    dateChange(value){
        if(value != null){
            this.queryForm.date_start = value[0];
            this.queryForm.date_end = value[1];
        }else{
            this.queryForm.date_start = '';
            this.queryForm.date_end = '';
        }
        this.getTableList('query');
    },

    // 翻页
    changePage(page){
      this.queryForm.page = page;
      this.getTableList();
    },
    sizeChange(val){
      this.queryForm.size = val;
      this.getTableList();
    },

  },
};
</script>
<style lang="less" scoped>
.stationGroupForm{
  height: 100%;
  display: flex;
  flex-direction: column;
  .tableArea{
    flex: 1;
    min-height: calc(100% - 237px);
  }
  .pageFoot{
    .statistical{
      font-size: 14px;
    }
  }
  .feedbackImg{
    width: 50px;height:50px;
  }
  .feedbackImg:not(:last-child){margin-right: 10px;}
}
</style>